// services/public-booking.service.ts
//
// Standalone service for the unauthenticated client-facing booking page
// (/book/confirm/:token). Deliberately has ZERO dependency on AuthService or
// setHeader() — a visitor clicking an emailed link has no CRM session, and
// this service must never assume one exists. Talks to publicBookingRoutes.js
// (mounted at /api/public/booking), which itself has no isAuth guard.

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { apiUrl } from '../../environments/environment';

export interface BookingSlot {
  start: string; // UTC ISO
  end:   string; // UTC ISO
}

export interface BookingPageData {
  status: number;
  msg?: string;
  request_status?: string;
  rep_name?: string;
  org_name?: string;
  customer_org_name?: string;
  duration_minutes?: number;
  rep_timezone?: string;
  slots?: BookingSlot[];
}

@Injectable({
  providedIn: 'root'
})
export class PublicBookingService {

  private apiLink = apiUrl + '/api/public/booking/';

  constructor(private http: HttpClient) {}

  async getBookingPage(token: string): Promise<BookingPageData> {
    return this.http.get<BookingPageData>(this.apiLink + token)
      .toPromise()
      .then(res => res as BookingPageData)
      .catch(() => ({ status: 0, msg: 'Could not connect to server. Please check your network connection.' }));
  }

  async confirmSlot(token: string, slot: BookingSlot, clientTimezone: string): Promise<any> {
    return this.http.post(this.apiLink + `${token}/confirm`, {
      slot_start:       slot.start,
      slot_end:         slot.end,
      client_timezone:  clientTimezone,
    }).toPromise().catch(() => ({ status: 0, msg: 'Could not connect to server. Please try again.' }));
  }

  async declineBooking(token: string): Promise<any> {
    return this.http.post(this.apiLink + `${token}/decline`, {})
      .toPromise()
      .catch(() => ({ status: 0, msg: 'Could not connect to server. Please try again.' }));
  }
}